import React from 'react';
import MypaAsInquiryContainer from 'containers/MypaAsInquiryContainer/MypaAsInquiryContainer';

export default function MypaAsInquiryPage() {
    return (
        <MypaAsInquiryContainer />
    )
}
